module.exports = __webpack_public_path__ + "static/img/logo-lg.7e3e053.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/hsm/img/logo-lg.png
// module id = kdcl
// module chunks = 1